/* global Office */
function buildRibbonRequestPayload(target, isAuthenticated) {
    return {
        tabs: [
            {
                id: target.tabId,
                groups: target.groups.map((group) => ({
                    id: group.id,
                    controls: group.controls.map((control) => ({
                        id: control.id,
                        enabled: control.requiresAuth === false ? true : isAuthenticated,
                    })),
                })),
            },
        ],
    };
}
export function createRibbonAuthManager(options) {
    const retryDelays = options.retryDelaysMs ?? [300, 800];
    const resolveBehavior = (value) => {
        if (typeof value === "function") {
            return value();
        }
        return value;
    };
    const updateRibbonForAuthState = (isAuthenticated) => {
        let atLeastOneUpdateSucceeded = false;
        options.targets.forEach((target) => {
            try {
                const payload = buildRibbonRequestPayload(target, isAuthenticated);
                Office.ribbon.requestUpdate(payload);
                atLeastOneUpdateSucceeded = true;
            }
            catch {
                // Ignore target mismatch and continue.
            }
        });
        if (!atLeastOneUpdateSucceeded && options.loggerPrefix) {
            console.warn(`${options.loggerPrefix} Unable to update ribbon state for any manifest target.`);
        }
    };
    const scheduleRibbonStateRetry = () => {
        retryDelays.forEach((delayMs) => {
            window.setTimeout(() => {
                updateRibbonForAuthState(options.authService.isAuthenticated());
            }, delayMs);
        });
    };
    const setTaskpaneStartupBehavior = (behavior, reason) => {
        try {
            const addinApi = Office.addin;
            if (typeof addinApi?.setStartupBehavior !== "function" || behavior === undefined) {
                return;
            }
            void Promise.resolve(addinApi.setStartupBehavior(behavior)).catch((error) => {
                if (options.loggerPrefix) {
                    console.warn(`${options.loggerPrefix} Failed to set startup behavior (${reason})`, error);
                }
            });
        }
        catch (error) {
            if (options.loggerPrefix) {
                console.warn(`${options.loggerPrefix} Could not set startup behavior (${reason})`, error);
            }
        }
    };
    const handleAuthStateChange = (isAuthenticated, reason) => {
        updateRibbonForAuthState(isAuthenticated);
        scheduleRibbonStateRetry();
        if (isAuthenticated) {
            setTaskpaneStartupBehavior(resolveBehavior(options.startupBehavior?.authenticated), `${reason} authenticated`);
        }
        else {
            setTaskpaneStartupBehavior(resolveBehavior(options.startupBehavior?.unauthenticated), `${reason} unauthenticated`);
        }
    };
    const syncRibbonFromAuth = async () => {
        try {
            await options.authService.initialize();
            const isAuthenticated = options.authService.isAuthenticated();
            handleAuthStateChange(isAuthenticated, "startup");
        }
        catch (error) {
            if (options.loggerPrefix) {
                console.warn(`${options.loggerPrefix} Failed to sync auth on startup`, error);
            }
        }
    };
    return {
        updateRibbonForAuthState,
        scheduleRibbonStateRetry,
        setTaskpaneStartupBehavior,
        syncRibbonFromAuth,
        handleAuthStateChange,
    };
}
